import { useCallback, useEffect, useState } from 'react'
import moment from 'moment/moment'
import useForm from 'tennders-common/form/hooks/useForm'
import { apiGet, apiPost } from 'tennders-stracture/libs/api'

const useMultipleSalesInvoiceForm = ({ selectedTransaction, initialForm, isCreditNote }) => {
  const [company, setCompany] = useState(null)
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null)
  const [companyInvoices, setCompanyInvoices] = useState([])
  const { form, onChange, errors, seterrors: setErrors, setform: setForm } = useForm({
    initialForm: initialForm || {
      company: null,
      dateOfReceipt: null,
      paymentTerm: null,
      defaultVat: null

    }
  })

  const getCompanySalesInvoicesRequest = useCallback(async () => apiPost(
    '/salesInvoices/ofCompany/' + company?.id,
    { attributes: '{id,uniqueFileName}' }
  ), [company?.id])

  const onCompanyChange = useCallback((company) => {
    // onChange('company', company)
    if (company) {
      setCompany(company)
      apiGet('/salesInvoice/initializeWithCompany/' + company.id).then(response => {
        setForm(prevForm => ({ ...prevForm, toCompany: response.toCompany, company: company?.id }))
      })
    }
  }, [JSON.stringify(form)])

  useEffect(() => {
    if (isCreditNote && company) {
      getCompanySalesInvoicesRequest().then((res) => {
        if (res) {
          setCompanyInvoices(res.map((item) => ({ id: item.id, label: item.uniqueFileName })))
        }
      })
    }
  }, [company])

  useEffect(() => {
    if (selectedTransaction?.matchedLoad?.company && !form.id) {
      apiGet('/companies/' + selectedTransaction.matchedLoad.company?.id).then(res => {
        onCompanyChange(res)
      })
    }
  }, [selectedTransaction])

  useEffect(() => {
    if (form.toCompany && !company?.paymentTerms) {
      apiGet('/companies/' + form.toCompany.id).then(res => onCompanyChange(res))
    }
  }, [form.toCompany])

  const calculatesDueDate = useCallback((selectedPaymentTerm, dateOfReceipt) => {
    const paymentTermDays = selectedPaymentTerm?.days
    if (typeof paymentTermDays !== 'undefined' && dateOfReceipt) {
      const dateToSet = moment(dateOfReceipt)
        .add('days', paymentTermDays)
        .set('hours', 17)
        .set('minutes', 0)
        .toDate()
      if (!form.id) {
        setForm(prev => ({
          ...prev,
          dueDate: dateToSet
        }))
      }
    }
  }, [selectedPaymentTerm, form])

  const onPaymentTermChange = useCallback((_, paymentTerm) => {
    if (paymentTerm) {
      const selectedPaymentTerm = company?.paymentTerms.find(item => parseInt(item.id, 10) === parseInt(paymentTerm, 10))
      setSelectedPaymentTerm(selectedPaymentTerm)
      calculatesDueDate(selectedPaymentTerm, form?.dateOfReceipt)
    }
    onChange('paymentTerm', paymentTerm)
  }, [company?.paymentTerms, form?.dateOfReceipt])

  const onDateOfReceiptChange = useCallback((_, dateOfReceipt) => {
    if (dateOfReceipt) {
      calculatesDueDate(selectedPaymentTerm, dateOfReceipt)
    }
    onChange('dateOfReceipt', dateOfReceipt)
  }, [selectedPaymentTerm])

  return {
    onDateOfReceiptChange,
    onPaymentTermChange,
    onCompanyChange,
    onChange,
    form,
    setForm,
    companyInvoices,
    calculatesDueDate,
    company,
    errors,
    setErrors,
    getCompanySalesInvoicesRequest
  }
}

export default useMultipleSalesInvoiceForm
